import dayjs from 'dayjs';
import React from 'react';
import { WebService } from '../Services/WebService';
import { TokenContext } from '../TokenContext';
import './EnrollmentDatePanel.scss'
import cn from 'classnames'

interface IProps {
    slotId: number;
    collapsed?: boolean;
    meetingLink?: string;
}

interface IState {
    enrollmentDate?: Date;
    time?: string;
}


export default class EnrollmentDatePanel extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            enrollmentDate: undefined
        }
    }

    componentDidMount(): void {
        new WebService(this.context.token).GetSlot(this.props.slotId)
            .then(res => this.setState({ enrollmentDate: dayjs(res.slotDate).toDate(), time: res.beginTime }));
    }

    render(): React.ReactNode {
        return <div className={cn('enrolDatePanelWrapper', { 'collapsed': this.props.collapsed })}>
            <div className={cn('enrolDatePanel', { 'withLink': !!this.props.meetingLink })} >
                <div>Дата и время оформления:</div>
                {!!this.state.enrollmentDate && <div>{dayjs(this.state.enrollmentDate).format("DD.MM.YYYY")} в {this.state.time}</div>}
            </div>
            {this.props.meetingLink && <a href={this.props.meetingLink}><div className='meetingLink'>
                <img style={{ height: '1.5rem' }} src={process.env.PUBLIC_URL + 'icons/meeting.svg'} />
                <div className='meetingLink-description'>Live с менеджером</div></div></a>}
            <div className='collapsedWrapper'><img src={process.env.PUBLIC_URL + '/icons/clock.svg'} /></div>
        </div >
    }

}
